
const OP_MODE = {
    1: '客保开始',
    10: '客保开始',
    5: '客保延期',
    9: '客保延期',
    2: '客保结束',
    3: '客保结束',
    6: '客保结束'
};

module.exports = {
    OP_MODE
};